export default {
  getVenueType: (state) => state.venueType,
};
